/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : AddEditPolicies.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import CustomFormTextFieldV3 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV3";
import { useDispatch } from "react-redux";
import policiesActions from "../../../redux/actions/policiesActions";
import { HandleApiActions } from "../../../redux/actions";
import CustomRadioButtonV3 from "../../../components/customComponentsV2/common/radioButton/CustomRadioButtonV3";
import DomainCard from "./DomainCard";

function AddEditPolicies({ open, title, onClose, selectedPolicyActions, setTriggerGetPolicy }) {
  const dispatch = useDispatch();

  const [policyName, setPolicyName] = useState("");
  const [policyKey, setPolicyKey] = useState("");
  const [actionAllowed, setActionAllowed] = useState({});
  const [isEffect, setIsEffect] = useState("ALLOW");
  const [domainList, setDomainList] = useState([
    { id: Date.now(), domain: null },
  ]);
  const [selectedDomainsAllList, setSelectedDomainsAllList] = useState([]);
  const [initialActionAllowed, setInitialActionAllowed] = useState({})
  const [initialEffect,setInitialEffect] = useState("")
  console.log("selectedDomainsAllList", selectedDomainsAllList);
  console.log("domainListdomainListdomainListdomainList", domainList);
  useEffect(() => {
    if (title?.toUpperCase() === "UPDATE POLICY") {
      console.log("selectedPolicyActions", selectedPolicyActions);
      const actionMap =
    selectedPolicyActions?.row?.domains_actions?.reduce((acc, item) => {
      acc[item?.domain] = item.actions;
      return acc;
    }, {}) || {};

      setIsEffect(selectedPolicyActions?.row?.effect || "");
      setInitialEffect(selectedPolicyActions?.row?.effect || "")
      setDomainList(
        selectedPolicyActions?.row?.domains_actions?.map((data) => ({
          id: Date.now() + Math.random(),
          domain: data?.domain,
        })),
      );
      setActionAllowed(
        actionMap
      );
      setInitialActionAllowed(actionMap);

      setPolicyName(selectedPolicyActions?.row?.policyName || "");
      setPolicyKey(selectedPolicyActions?.row?.policy_key || "");
    }
  }, []);
  console.log("ActionAllolwedActionAllowed", actionAllowed);

  useEffect(() => {
    dispatch(HandleApiActions({ ...policiesActions.get_domains }));
  }, []);

  const handleAddMore = () => {
    setDomainList((prev) => [...prev, { id: Date.now(), domain: null }]);
  };

  const isActionValid = useCallback(
    (domain) => {
      console.log("Checking validity for domain:", domain);
      console.log("actionAllowed:", actionAllowed);
      const actionsForDomain = actionAllowed?.[domain] || [];
      console.log("actionsForDomain", actionsForDomain?.length);
      return actionsForDomain.length > 0;
    },
    [actionAllowed],
  );

  const handleDomainChange = useCallback((id, value) => {
    isActionValid(id);
    setDomainList((prev) =>
      prev?.map((item) =>
        item.domain === id ? { ...item, domain: value } : item,
      ),
    );
  }, []);

  const handleDeleteDomain = useCallback((index, item) => {
    console.log("index:", index);
    console.log("item:", item);
   
 
    if (item) {
      setDomainList((prev) => prev.filter((_, i) => i !== index));
 if (index === 0 && domainList?.length <1) {
       setDomainList([{ id: Date.now(), domain: null }]);
    }
      setActionAllowed((prev) => {
        const updated = { ...prev };
        delete updated[item.domain];
        return updated;
      });
    } else {
      setDomainList([{ id: Date.now(), domain: null }]);
     
    }
  }, []);

  console.log("DomainList", domainList);
  console.log("actionAllowedactionAllowed", actionAllowed);

  const isFormValid = useMemo(() => {
    const isPolicyNameValid = policyName?.trim()?.length > 0;
    const isPolicyKeyValid = policyKey?.trim()?.length > 0;
    const isEffectValid = Boolean(isEffect); // "ALLOW" or "DENY"
    const isActionValid = Object.values(actionAllowed || {}).some(
      (arr) => Array.isArray(arr) && arr.length > 0,
    );
    return (
      isPolicyNameValid && isPolicyKeyValid && isEffectValid && isActionValid
    );
  }, [policyName, policyKey, isEffect, actionAllowed]);

  const isFormValidEdit = () => {
  const actionsChanged =
    JSON.stringify(actionAllowed) !== JSON.stringify(initialActionAllowed);

  const effectChanged = isEffect !== initialEffect;

  return actionsChanged || effectChanged;
};

  const handleOnClick = async () => {
    if (title?.toUpperCase() === "UPDATE POLICY") {
      const reqObj = {
        policyJson: {
          effect: isEffect,
          actions: Object.values(actionAllowed).flat(),
          conditions: {
            entityScope: "GLOBAL",
            implicitParentView: true,
            dependenciesSatisfied: true,
          },
        },
        changeReason: "string",
      };

      console.log("---reqObj---", reqObj);
      await dispatch(
        HandleApiActions({
          ...policiesActions.update_policies,
          api_name: `/UCM/policies/${policyKey}/versions`,
          params: reqObj,
          show_toast: true,
        }),
      ).then(() => {

        setTriggerGetPolicy(prev => !prev)
         onClose();
      });
    } else if (title?.toUpperCase() === "ADD POLICY") {
      const reqObj = {
        policyKey: policyKey,
        policyName: policyName,
        policyType: "GLOBAL",
        policyJson: {
          effect: isEffect,
          actions: Object.values(actionAllowed).flat(),
          conditions: {
            entityScope: "GLOBAL",
            implicitParentView: true,
            dependenciesSatisfied: true,
          },
        },
      };

      console.log("---reqObj---", reqObj);
      await dispatch(
        HandleApiActions({
          ...policiesActions.add_policies,
          params: reqObj,
          show_toast: true,
        }),
      ).then(() => {
        const resp = dispatch(
          HandleApiActions({ ...policiesActions.get_policies }),
        );
        if (!resp?.error) {
          onClose();
        }
      });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1.5 },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
            pb: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>

          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            mt: 2,
            maxHeight: "60vh",
            overflowY: "auto",
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#b0b0b0",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#888",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
              borderRadius: "8px",
            },
          }}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
                width: "100%",
              }}
            >
              <CustomFormTextFieldV3
                disabled={title?.toUpperCase() === "UPDATE POLICY"}
                label="Policy Key"
                required
                type="text"
                fldType="text"
                value={policyKey}
                setValue={setPolicyKey}
                placeholder="Enter Policy Key"
              />

              <CustomFormTextFieldV3
                disabled={title?.toUpperCase() === "UPDATE POLICY"}
                label="Policy Name"
                required
                type="text"
                fldType="text"
                value={policyName}
                setValue={setPolicyName}
                placeholder="Enter Policy Name"
              />
              

              <CustomRadioButtonV3
                label="Effect"
                required
                data={["ALLOW", "DENY"]?.map((item) => ({
                  label: item,
                  value: item,
                }))}
                value={isEffect}
                onChange={(e) => setIsEffect(e.target.value)}
                direction="column"
                gap={1.5}
              />
            </Box>

            <Box>
              <Box
                sx={{
                  height: "30vh",
                  overflowY: "auto",
                }}
              >
                {domainList?.map((item, index) => (
                  <DomainCard
                    key={item.id}
                    isActionValid={isActionValid}
                    setSelectedDomainsAllList={setSelectedDomainsAllList}
                    domainList={domainList}
                    selectedValues={actionAllowed}
                    setSelectedValues={setActionAllowed}
                    handlOnDelete={() => handleDeleteDomain(index, item)}
                    index={index}
                    domain={item.domain}
                    onChange={(value) => handleDomainChange(item.domain, value)}
                  />
                ))}
                {selectedDomainsAllList?.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <CustomButtonV2
                      disabled={
                        !isActionValid(
                          domainList?.[domainList.length - 1]?.domain || null,
                        )
                      }
                      type="cancel"
                      btnName="Add More"
                      handleOnClick={handleAddMore}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            borderTop: "1px solid #e0e0e0",
            pt: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <>
            <CustomButtonV2
              type="cancel"
              btnName="Cancel"
              handleOnClick={onClose}
            />
            <CustomButtonV2
              disabled={  title?.substring(0, 6).toLowerCase() === "update" ? !isFormValidEdit() :!isFormValid}
              type="submit"
              btnName={
                title?.substring(0, 6).toLowerCase() === "update"
                  ? "Update Policy"
                  : "Create Policy"
              }
              handleOnClick={handleOnClick}
            />
          </>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddEditPolicies;

AddEditPolicies.propTypes = {
  open: PropTypes.any,
  title: PropTypes.any,
  onClose: PropTypes.any,
  selectedPolicyActions: PropTypes.any,
  setTriggerGetPolicy: PropTypes.any,
};
